/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GetVersionViewDto { 
    /**
     * версия приложения
     */
    version: string;
    /**
     * дата-время билда
     */
    buildTime: string;
    /**
     * сведения из git-а
     */
    gitInfo: string;
}

